import {Viewer} from './Viewer';


document.addEventListener("DOMContentLoaded", function () {

	let container = document.querySelector('.rotate-object');
	if (container) {
		const hash = location.hash ? location.hash : {};

		let view = new Viewer(container, {
			kiosk: Boolean(hash.kiosk),
			model: hash.model || '',
			preset: hash.preset || '',
			cameraPosition: hash.cameraPosition
				? hash.cameraPosition.split(',').map(Number)
				: null
		});

		view
			.load(container.getAttribute('data-path'))
			.catch((e) => {
			})
			.then((gltf) => {
			});

		container.addEventListener('mouseover', () => {
			container.classList.add('hovered');
		});

		container.addEventListener('touchstart', () => {
			container.classList.add('hovered');
		})
	}

});